import React from "react";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ReceiverInSendList, {generateReceiverKey} from "../component/ReceiverInSendList";
import { AccessibleDialog } from "../../../components/composed";

export default function ReceiverApproveDialog(props) {
    return (
        <AccessibleDialog
            open={props.open}
            onClose={props.handleClose}
            title={`Please confirm sending to ${props.receivers.length} recipients`}
            maxWidth="md"
            actions={
                <>
                    <Button onClick={props.handleClose} color="primary">
                        Close
                    </Button>
                    <Button
                        onClick={props.handleApprove}
                        color="primary"
                        autoFocus
                        disabled={props.receivers.length === 0}
                        aria-label={`Send emails to ${props.receivers.length} recipients`}
                    >
                        Send
                    </Button>
                </>
            }
        >
            <List>
                {props.receivers.map(receiver => (
                    <ReceiverInSendList
                        key={generateReceiverKey(receiver.id)}
                        receiver={receiver}
                        handleOnItemClear={() => props.handleOnItemClear(receiver)}
                        emailTypes={props.emailTypes}
                        changeCurrentEmailType={false}
                    />
                ))}
            </List>
        </AccessibleDialog>
    );
}
